import React from 'react';
import { Link } from 'react-router-dom';
import { I18n } from 'react-redux-i18n';

const Breadcrumbs = ({
    paths = []
}) => {
    if (paths.length === 0) return null;

    return (
        <div className="breadcrumbs">
            <span key={"breadcrumb_home"}>
                <Link to='/dashboard'>
                    {I18n.t('auth.home')}
                </Link>
            </span>
            {paths.map(
                (path, _index) => {
                    const pathIsTheLast = _index === paths.length - 1;
                    return (
                        <span 
                            key={"breadcrumb_" + path.name}
                            style={pathIsTheLast ? { opacity: '0.6' } : { }}
                        >
                            {" > "} 
                            {pathIsTheLast ?
                                path.name :
                                <Link to={path.link}>
                                    {path.name}
                                </Link>
                            }
                        </span>
                    )
                }
            )}
        </div>
    );
}

export default Breadcrumbs;